import React from 'react';
import { InlineWidget } from 'react-calendly';
import { sheduleLink } from '../../constant/Constant';

const PricingContactV2 = () => {
  return (
    <div className="relative mt-32">
      <InlineWidget url={sheduleLink} />
    </div>
  );
};

export default PricingContactV2;